import { useQuery } from '@tanstack/react-query';

import { getNextGamedayOrEvent } from '@/infrastructure/network/data/scheduled-event/next-gameday-event';

export const useNextEventOrGamedayQuery = (teamLeagueUuid: string, seasonUuid?: string) => {
	return useQuery({
		queryKey: ['NEXT_GAMEDAY_EVENT', teamLeagueUuid, seasonUuid],
		queryFn: () => getNextGamedayOrEvent({ teamLeagueUuid, seasonUuid: seasonUuid! }),
		enabled: !!(seasonUuid && teamLeagueUuid)
	});
};
